import { Link } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

export function EditClientHeader() {
  return (
    <div className="px-6 pt-5 pb-4 border-b border-brand-100">
      <Link
        to="/clients"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-600 hover:text-brand-700 mb-3"
      >
        <ArrowLeftOutlined />
        Back to clients
      </Link>
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold text-gray-900 tracking-tight">Edit Client</h1>
          <p className="text-sm text-gray-500 mt-1">Update client details and workspace settings</p>
        </div>
      </div>
      <div className="mt-3 h-1.5 w-16 rounded-full bg-gradient-to-r from-brand-400 to-brand-600" aria-hidden />
    </div>
  )
}
